// styles
import { MainVisual } from '../../styles';

// ----------------------------------------------------------------------

export default function MainPage() {
  return <MainVisual />;
}